module.exports = __webpack_public_path__ + "img/what-flow-03.c002a506.svg";